import React from "react";

type ProdutoDescricaoProps = {
  titulo: string,
  descricao: string,
};

type ProdutoDescricaoState = {
  aberto: boolean,
};

class ProdutoDescricao extends React.Component<ProdutoDescricaoProps, ProdutoDescricaoState> {

  private QTD_CARACTERES = 150;

  constructor(props: ProdutoDescricaoProps) {
    super(props);

    this.toggleDescricao = this.toggleDescricao.bind(this);

    this.state = {
      aberto: false,
    };
  }

  toggleDescricao(): any {
    this.setState({ aberto: !this.state.aberto });
  }

  render(): any {
    const { titulo, descricao } = this.props;

    if (descricao.length > this.QTD_CARACTERES) {
      return (
        <div className="product-descriptor">
          <p className="title">{titulo}</p>
          <p className="description">
            <span
              dangerouslySetInnerHTML={{ __html: !this.state.aberto ?
                descricao.replace(/<[^>]*>?/gm, "").substring(0, this.QTD_CARACTERES) + "..." : descricao
              }}></span>
              <span className="less" onClick={ this.toggleDescricao }>
                &nbsp;&nbsp; { this.state.aberto ? "Ver menos" : "Ver mais"}
              </span>
          </p>
        </div>
      );
    } else {
      return (
        <div className="product-descriptor">
          <p className="title">{titulo}</p>
          <p className="description">
            <span dangerouslySetInnerHTML={{ __html: descricao }}></span>
          </p>
        </div>
      );
    }
  }
}

export default ProdutoDescricao;
